import { initializeDatasets } from '@libs/datasets';

import datasets from './redux.datasets';

const initialState = {
    ...initializeDatasets(datasets)
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        default: {
            return state;
        }
    }
};
